import { render, staticRenderFns } from "./customerAnatomy.vue?vue&type=template&id=c2d0b59e"
import script from "./customerAnatomy.vue?vue&type=script&lang=js"
export * from "./customerAnatomy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports